var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsRedRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8362 0.573242L9.76456 7.64324L2.69456 0.573242L0.337891 2.92991L7.40789 9.99991L0.337891 17.0699L2.69456 19.4266L9.76456 12.3566L16.8362 19.4266L19.1929 17.0699L12.1229 9.99991L19.1929 2.92991L16.8362 0.573242Z",
    fill: "#E41B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsRedRejected);
export default __webpack_public_path__ + "static/media/icons-red-rejected.09d8adfadcf2a9d86ced44713420373a.svg";
export { ForwardRef as ReactComponent };